import { render, staticRenderFns } from "./consent-view.vue?vue&type=template&id=ad8622b6&scoped=true"
import script from "./consent-view.vue?vue&type=script&lang=js"
export * from "./consent-view.vue?vue&type=script&lang=js"
import style0 from "./consent-view.vue?vue&type=style&index=0&id=ad8622b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8622b6",
  null
  
)

export default component.exports